import { render, staticRenderFns } from "./scroll-bar.vue?vue&type=template&id=64e2a864&scoped=true&"
import script from "./scroll-bar.vue?vue&type=script&lang=js&"
export * from "./scroll-bar.vue?vue&type=script&lang=js&"
import style0 from "./scroll-bar.vue?vue&type=style&index=0&id=64e2a864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e2a864",
  null
  
)

export default component.exports